<template functional>
    <div class="tabFilters">
        <div class="tabFilters-tabs">
            <div class="tabFilters-tabs-container">
                <ul class="tabFilters-tabs-container-list">
                    <li v-for="(array, option) in items.filterOptions" class="tabFilters-tabs-container-list-item" :key="option">
                        <input type="radio" :name="option" id="empty" value="" v-model="items.filters[option]">
                        <label for="empty">All</label>
                        <template v-for="item in array">
                            <input type="radio" :name="option" :id="item" :value="item" v-model="items.filters[option]">
                            <label :for="item">{{item}}</label>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['items']
}
</script>